import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import { googleErrorText } from "./auth-errors.ts";

/**
 * Отказ входа через сервис, пришедший в адресе как `?auth_error=`.
 *
 * ⚠️ Отдельным компонентом, а не хуком в корневом экране, и это обязательное
 * следствие того, что корень перестал быть экраном: он теперь либо форма
 * входа, либо переадресация на домашнюю страницу кабинета. Отказ обязан
 * пережить эту переадресацию, поэтому баннер рисуется на форме входа и на
 * обоих экранах, куда корень может привести: расписание (домашняя) и уроки.
 * При `google_other_user` сессия остаётся живой, показывается кабинет,
 * и сообщение, живущее только на форме входа, никто никогда не увидит.
 *
 * Компонент, а не хук, ещё и потому, что стирание параметра это побочный
 * эффект: пока баннера на экране нет, параметр трогать нельзя, иначе он
 * пропадёт РАНЬШЕ, чем доедет до экрана, который его показывает.
 *
 * Параметр вычищается из адреса сразу: иначе он переживёт перезагрузку и уедет
 * в пересланную ссылку, то есть человек будет видеть чужой отказ.
 * `replace: true`, чтобы «назад» не возвращал на тот же баннер.
 *
 * Чистим ТЕКУЩИЙ путь, а не корень: компонент живёт уже на двух адресах, и
 * жёсткая «/» здесь означала бы переброс с экрана уроков на корень и обратно.
 */
export function AuthErrorBanner() {
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const raw = params.get("auth_error");
  const [code, setCode] = useState<string | null>(raw);

  useEffect(() => {
    if (raw === null) return;
    setCode(raw);
    const rest = new URLSearchParams(location.search);
    rest.delete("auth_error");
    const search = rest.toString();
    void navigate({ pathname: location.pathname, search: search ? `?${search}` : "" }, { replace: true });
  }, [raw, navigate, location.pathname, location.search]);

  if (code === null) return null;
  return (
    <p className="auth-banner" role="alert">
      {googleErrorText(code)}
    </p>
  );
}
